<script setup>
import AssetsSelect from '@/views/experimental/map-view/AssetsSelect.vue';
import { getBaseURL } from '@/config.js';
</script>
<template>
  <div>
    <div class="mt-5">
      <p>Key In <b>Receipt Information</b> and Proceed.</p>

      <label class="vs-input--label">Vehicle Select</label>
      <!-- <ejs-multiselect
        id="multiselect"
        :dataSource="fleets"
        v-model="receiptInfo.assetId"
        :fields="fields"
        popupHeight="400px"
        mode="CheckBox"
        :filtering="filtering"
        enableGroupCheckBox="true"
        showDropDownIcon="true"
        allowFiltering="true"
        filterType="contains"
        maximumSelectionLength="1"
        filterBarPlaceholder="Search"
        showSelectAll="false"
        placeholder="Select Assets"
        enableVirtualization="true"
      >
      </ejs-multiselect> -->

      <AssetsSelect
        @selected="
          (v) => {
            // $emit('selected', v);
            receiptInfo.assetId = v;
          }
        "
        :dataSource="fleets"
        :style="{ width: `500px` }"
        :filtering="filtering"
        :f="fields"
        :singleSelect="true"
      />
      <br />
      <label class="vs-input--label">Maintenance Vehicles</label>
      <!-- <ejs-multiselect
        id="multiselect2"
        :dataSource="fmsSelection"
        v-model="receiptInfo.fmsAssetId"
        :fields="fields2"
        popupHeight="400px"
        mode="CheckBox"
        :filtering="filtering"
        enableGroupCheckBox="true"
        showDropDownIcon="true"
        allowFiltering="true"
        filterType="contains"
        maximumSelectionLength="1"
        filterBarPlaceholder="Search"
        showSelectAll="false"
        placeholder="Select Assets"
        enableVirtualization="true"
      >
      </ejs-multiselect> -->

      <AssetsSelect
        @selected="
          (v) => {
            // $emit('selected', v);
            receiptInfo.fmsAssetId = v;
          }
        "
        :dataSource="fmsSelection"
        :style="{ width: `500px` }"
        :filtering="filtering"
        :f="fields2"
        :singleSelect="true"
      />

      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-half">
          <vs-input
            label="Total Price (RM)"
            v-model="receiptInfo.price"
            class="w-full mt-4"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-half">
          <vs-input
            label="Location"
            v-model="receiptInfo.location"
            class="w-full mt-4"
          />
        </div>
      </div>
      <br />
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-half">
          <vs-input
            type="datetime-local"
            label="Time"
            v-model="receiptInfo.time"
            class="w-full mt-4"
          />
        </div>
        <!--       <div class="vx-col md:w-1/2 w-half">
                Attachment/Receipts
                <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" v-on:vdropzone-success="vehicleDocumentsUpload($event,indextr)"  v-on:vdropzone-removed-file="vehicleDocumentsRemove($event,indextr)"></vue-dropzone>
               </div>    -->
      </div>

      <vs-button color="primary" @click="submitDetails()"
        >Add Receipt</vs-button
      >
      &nbsp;
    </div>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard';
import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { Query, Predicate } from '@syncfusion/ej2-data';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import vSelect from 'vue-select';

export default {
  props: {
    fleets: Array,
    fmsSelection: Array,
  },
  data() {
    return {
      quickSelect: null,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      allowCustomValue: true,
      loadingWizard: false,
      errorMsg: null,
      fleetAlarm: [],
      fleetNotification: [],
      fleetNotificationConfig: [30, 14, 3],
      fields: { groupBy: 'assetGroup', text: 'assetName', value: 'assetId' },
      fields2: {
        groupBy: 'assetGroup',
        text: 'assetName',
        value: 'fmsAssetId',
      },
      receiptInfo: {
        assetId: null,
        fmsAssetId: null,
        fuel: 0,
        priceperliter: 0,
        price: 0,
        time: '',
        location: '',
        files: [],
      },
      dropzoneOptions: {
        url: getBaseURL() + '/fleets/uploadFiles',
        thumbnailWidth: 150,
        maxFilesize: 10.0,
        maxFiles: 15,
        addRemoveLinks: true,
        //autoProcessQueue: false
      },
    };
  },
  watch: {},
  methods: {
    vehicleDocumentsUpload(event, index) {
      const x = JSON.parse(event.xhr.response).path;
      const str = x.substring(25);
      this.receiptInfo[index].files.push(str);
    },
    vehicleDocumentsRemove(event, index) {
      const self = this;
      const removedFile = event.upload.filename;
      const arr = self.receiptInfo[index].files;
      if (arr.length == 1) {
        self.receiptInfo[index].files = [];
        return;
      }
      arr.forEach((element, i) => {
        const y = element.split('_', 4);
        if (y[3].includes(removedFile)) {
          self.receiptInfo[index].files.splice(i, 1);
        }
      });
    },

    submitDetails() {
      const self = this;
      if (
        (!self.receiptInfo.assetId && !self.receiptInfo.fmsAssetId) ||
        self.receiptInfo.price < 1 ||
        self.receiptInfo.time == ''
      ) {
        return self.$vs.notify({
          title: 'Error',
          text: 'Asset,Volume,Price & Time are required fields.',
          iconPack: 'feather',
          icon: 'icon-refresh-cw',
          color: 'warning',
        });
      }
      if (
        self.receiptInfo.assetId != null &&
        self.receiptInfo.fmsAssetId != null
      ) {
        return self.$vs.notify({
          title: 'Error',
          text: 'Select Either from Vehicle / Maintenance Asset list only.',
          iconPack: 'feather',
          icon: 'icon-refresh-cw',
          color: 'warning',
        });
      }
      self.$http
        .post('receipts-toll/submit', {
          userInfo: self.userInfo,
          receiptInfo: self.receiptInfo,
        })
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.$emit('exit', true);
            return self.$vs.notify({
              title: 'New record added',
              text: 'Receipt info added!',
              iconPack: 'feather',
              icon: 'icon-refresh-cw',
              color: 'success',
            });
          } else {
            self.$emit('exit', true);
            if (response.data.error) {
              return self.$vs.notify({
                title: 'Error',
                text: response.data.error,
                iconPack: 'feather',
                icon: 'icon-refresh-cw',
                color: 'warning',
              });
            } else {
              return self.$vs.notify({
                title: 'Error',
                text: 'Could not created FMS Receipt record at this time.Try again later.',
                iconPack: 'feather',
                icon: 'icon-refresh-cw',
                color: 'warning',
              });
            }
          }
        })
        .catch(function (error) {
          self.$emit('exit', true);
        });
    },
  },
  mounted() {},
  components: {
    FormWizard,
    TabContent,
    MultiSelectPlugin,
    Query,
    Predicate,
    vueDropzone: vue2Dropzone,
    vSelect,
  },
};
</script>

<style scoped>
@import '../../../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-vue-dropdowns/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';

.e-multiselect {
  border-bottom: 1px solid #ffffff;
  font-family: 'Montserrat';
}
.e-multi-select-wrapper {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  font-family: 'Montserrat';
  height: 40px;
}

.e-multi-select-wrapper-e-delimiter {
  font-family: 'Montserrat';
}
.error {
  color: 'red';
  font-weight: 'bold';
  font-size: '20px';
}
.vs-table {
  overflow-y: visible !important;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
</style>
